import React, { Component } from 'react';

import { scroller, Element } from 'react-scroll';  

//import AnimateHeight from 'react-animate-height';

const borderButton = {
  border: 'none'
}

export default class AldeiaSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      smallText: "No Parque Natural da Serra da Estrela, encontra-se o Sabugueiro, a aldeia mais recôndita e próxima do cume da Serra da Estrela, erguida e aconchegada entre montes e naturalmente protegida por rochedos de granito.",
      longText: "A sua construção mais antiga encontra-se envolta à Igreja Paroquial, com ruas pequenas e inclinadas, cada uma com uma história para contar, um cheiro, um sabor.<br>\
      O sabugueiro não é apenas um ponto de passagem, convidamos a procurar a calçada escura e sem querer, achamos as marcas das suas famílias, gentes que dão vida e são a essência desta Terra. Gente que mantém ainda viva os ecos do seu passado, dedicada ao cultivo da terra, à pastorícia, ao comércio…<br>\
      Ao virar da esquina encontramos velhos agricultores com as suas colheitas, rebanhos de cabras que se apresentam pelo seu chocalhar, mulheres com feixes de giestas na cabeça ou então com braçados de couves.<br>\
      Acalentam-nos os tabuleiros de pão quentinho a sair do forno comunitário, os biscoitos nos cestos com o sabor da avó, o pão de açúcar a pingar enrolado num avental.<br>\
       Ouve-se o som da água a descer na fervença que simbolisa finalmente o bom tempo, o arrastar das urgueiras secas para queimar, o cheiro que vem das lareiras que furam os telhados e adivinham que tempo “não está cheiroso”, a atmosfera que fica especial, o ambiente enevoado e esperamos então que o céu nos mostre o seu sorriso com a neve branquinha.<br>\
      Estendem-se roupas negras no estendal, as comadres a “coscuvilhar”, a criança a chegar, o silêncio que se faz sentir é quebrado pelo sino a badalar.<br>\
      Nem a cinza que o incêndio deixou e devastou grandes áreas da terra, consegue esconder a alvura dos montes, o rio por onde corre e vai deixando sinais de vida e o verde começa a aparecer, ainda falta muito até que maia amarela e branca cubra a encosta, mas o seu cheiro em dias quentes que nos está na memória vai voltar.<br>\
      ",
      height: '50%',
      isOpen: false
    };
  }


  toggle = () => {

    const height  = this.state.height;

    this.setState({
      height: height === '50%' ? 'auto' : '50%',
    });

  };

  toggleText = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });

    scroller.scrollTo("textElement", {
      duration: 600,
      delay: 0,
      offset: -130,
      smooth: true
    })

  }

  returnButtonStyle = () => {

    if(this.state.isOpen){
      return(<span>Ler Menos <i className="fas fa-angle-up"></i></span>)
    }
    else {
      return(<span>Ler Mais <i className="fas fa-angle-down"></i></span>)
    }

  }

  render() {


    return (
      <section id="aldeia-text-section">
        <Element name="textElement"></Element>
        <h1>A aldeia</h1>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-8 offset-md-2">

              <p className="about-us-text">{this.state.smallText}</p>

              {this.state.isOpen && 

                <p
                className="about-us-text"
                dangerouslySetInnerHTML={{
                  __html: this.state.longText
                }}
                />
              }

              
              <button style={borderButton} type="button" className="btn btn-outline-primary" onClick={()=>{this.toggleText()}}>{this.returnButtonStyle()}</button>
            </div>
          </div>
        </div>

      </section>
    )
  }
}
